import React, { useEffect } from 'react';
import { Button } from 'antd';
import { useChat } from '../../contexts/ChatContext';
import chatService from '../../services/chatService';

const TestChatNotification = () => {
  const { onMessage, sendMessage } = useChat();

  useEffect(() => {
    // Listen for test messages
    const handleTestNotification = (message) => {
      if (message.type === 'test:notification') {
        console.log('Test notification received:', message);
      }
    };
    
    const unsubscribe = chatService.on('message', handleTestNotification);

    return () => {
      if (unsubscribe) unsubscribe();
    };
  }, []);

  const triggerTestNotification = () => {
    // Simulate a new message
    const testMessage = {
      id: `test-${Date.now()}`,
      content: 'Ceci est un message de test',
      senderId: 'test-user-123',
      sender: {
        id: 'test-user-123',
        name: 'Utilisateur de test',
        avatar: null
      },
      conversationId: 'test-conversation-123',
      createdAt: new Date().toISOString(),
      isRead: false
    };

    // Emit a test message
    if (sendMessage) {
      sendMessage(testMessage);
    }
  };

  return (
    <div style={{ padding: '20px' }}>
      <h2>Test des Notifications de Chat</h2>
      <Button type="primary" onClick={triggerTestNotification}>
        Déclencher une notification de test
      </Button>
      <p style={{ marginTop: '10px', color: '#666' }}>
        Cliquez sur le bouton pour tester l'affichage d'une notification de chat.
      </p>
    </div>
  );
};

export default TestChatNotification;
